import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import TeacherHome from '../views/TeacherHome.vue';
import Admin from '../views/Admin.vue';
import Header from '../components/Header.vue';
import Banner from '../components/Banner.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    components: {
      default: Login,
      header: Header,
    },
  },
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home,
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW', 'AW'],
    },
  },
  {
    path: '/chatroom',
    name: 'Chatroom',
    components: {
      default: () => import('../views/Chatroom.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW'],
    },
  },
  {
    path: '/myclass/:classId',
    name: 'MyClass',
    components: {
      default: () => import('../views/MyClass.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['SW'],
    },
  },
  {
    path: '/myexercise/:classId',
    name: 'MyExercise',
    components: {
      default: () => import('../views/MyExercise.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['SW'],
    },
  },
  {
    path: '/uploadcode/:classId',
    name: 'UploadCode',
    components: {
      default: () => import('../views/UploadCode.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW'],
    },
  },
  {
    path: '/checkcode/:classId',
    name: 'TeacherCheckCode',
    components: {
      default: () => import('../views/TeacherCheckCode.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['TW', 'AW'],
    },
  },
  {
    path: '/cwhuntList/:classId',
    name: 'CwhuntList',
    components: {
      default: () => import('../views/CwhuntList.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW'],
    },
  },
  {
    path: '/myquestions/:problemId',
    name: 'MyQuestions',
    components: {
      default: () => import('../views/MyQuestions.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW'],
    },
  },
  {
    path: '/AddEditQuestion',
    name: 'AddEditQuestion',
    components: {
      default: () => import('../views/AddEditQuestion.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW'],
    },
  },
  {
    path: '/questionPost/:questionId',
    name: 'QuestionPost',
    components: {
      default: () => import('../views/QuestionPost.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW'],
    },
  },
  {
    path: '/ranklists',
    name: 'RankLists',
    components: {
      default: () => import('../views/RankLists.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW'],
    },
  },
  {
    path: '/mygrade',
    name: 'MyGrade',
    components: {
      default: () => import('../views/MyGrade.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW'],
    },
  },
  {
    path: '/personal',
    name: 'Personal',
    components: {
      default: () => import('../views/Personal.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW'],
    },
  },
  {
    path: '/alumni',
    name: 'Alumni',
    components: {
      default: () => import('../views/Alumni.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['SW', 'TW', 'AW'],
    },
  },
  {
    path: '/classesAndQuestions',
    name: 'TeacherHome',
    components: {
      default: TeacherHome,
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['TW'],
    },
  },
  {
    path: '/allQuestions',
    name: 'TeacherAllQuestion',
    components: {
      default: () => import('../views/TeacherAllQuestion.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['TW'],
    },
  },
  {
    path: '/classList',
    name: 'TeacherClassList',
    components: {
      default: () => import('../views/TeacherClassList.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['TW'],
    },
  },
  {
    path: '/teacherCwhuntList/:classId',
    name: 'TeacherCwhuntList',
    components: {
      default: () => import('../views/TeacherCwhuntList.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['TW'],
    },
  },
  // {
  //   path: '/teacherAllStudents/:classId',
  //   name: 'TeacherAllStudents',
  //   components: {
  //     default: () => import('../views/TeacherAllStudents.vue'),
  //     header: Header,
  //   },
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/teacherOneStudent/:classId',
    name: 'TeacherOneStudent',
    components: {
      default: () => import('../views/TeacherOneStudent.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['TW'],
    },
  },
  {
    path: '/classExercise/:classId',
    name: 'ClassExercise',
    components: {
      default: () => import('../views/ClassExercise.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['TW', 'SW'],
    },
  },
  {
    path: '/admin',
    name: 'Admin',
    components: {
      default: Admin,
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/analysis',
    name: 'AdminAnalysis',
    components: {
      default: () => import('../views/AdminAnalysis.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/loginWatch',
    name: 'AdminLoginWatch',
    components: {
      default: () => import('../views/AdminLoginWatch.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/teacherList',
    name: 'AdminTeacherList',
    components: {
      default: () => import('../views/AdminUserList.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/studentList',
    name: 'AdminStudentList',
    components: {
      default: () => import('../views/AdminUserList.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/courseList',
    name: 'AdminCourseList',
    components: {
      default: () => import('../views/AdminCourseList.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/course/:courseId',
    name: 'AdminOneCourse',
    components: {
      default: () => import('../views/AdminOneCourse.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/classList',
    name: 'AdminClassList',
    components: {
      default: () => import('../views/AdminClassList.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/studentList/:classId',
    name: 'AdminStudentListByClass',
    components: {
      default: () => import('../views/AdminStudentListByClass.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/noticeboard',
    name: 'AdminNoticeboard',
    components: {
      default: () => import('../views/AdminNoticeboard.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/noticeboard/analysis/:noticeboardId',
    name: 'AdminNoticeboardAnalysis',
    components: {
      default: () => import('../views/AdminNoticeboardAnalysis.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/cwhunt',
    name: 'AdminCwhunt',
    components: {
      default: () => import('../views/AdminCwhunt.vue'),
      header: Header,
      banner: Banner,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '/admin/grade',
    name: 'AdminGrade',
    components: {
      default: () => import('../views/AdminGrade.vue'),
      header: Header,
    },
    meta: {
      requiresAuth: true,
      role: ['AW'],
    },
  },
  {
    path: '*',
    redirect: '/',
    hidden: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  },
});

export default router;
